import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEye, faDownload } from '@fortawesome/free-solid-svg-icons';
import Tooltip from "@mui/material/Tooltip";
import {
    faSearch,
    faTrash,
  faCheckCircle,
  faSignOutAlt,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";
import TablePaginationActions from "../../../base-components/TablePaginationActions";
import ExportDropdownMenu from "../../../base-components/ExportDropdownMenu";
import { MemberReport } from "./MemberReport";
import { Box, Table, TableBody, CircularProgress, TableCell, TableFooter, TableHead, TablePagination, TableRow, Menu, MenuItem, IconButton } from "@mui/material";
import Popup from "../../../base-components/Popup";
import dayjs from "dayjs";
import { PageHeader } from "../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function MemberHistory() {
  const navigate = useNavigate();
  const {member_id} = useParams()
  const [attendance, setAttendance] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [member, setMember] = useState(null);

  const [role , setRole] = useState('')
  const [company_id , setCompanyID] = useState('')
  const [location_id , setLocationID] = useState('')

  const [isSuccessAlert , setIsSuccessAlert] = useState(false)
  const [isFaliureAlert , setIsFailureAlert] = useState(false)
  const [successMessage , setSuccessMessage] = useState('')
  const [failureMessage , setFailureMessage] = useState('')
  const [isPopupOpen , setIsPopupOpen] = useState(false)
    const [filteredAttendance, setFilteredAttendance] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null);


  useEffect(()=> {
    const sessionStr = sessionStorage.getItem('user-info');
    if(sessionStr){
      const session = JSON.parse(sessionStr);
      setRole(session.user.role)
      setCompanyID(session.user.company_id)
      setLocationID(session.user.location_id)
    }
    else {
      navigate('/login');
    }
  },[])

  useEffect(() => {
    if(role) {
      const fetchData = async () => {
        setLoading(true);
        try {
          await Promise.all([
            getAttendance(),
            getMemberByID()
          ])
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
      fetchData();
    };
  }, [role]);

  async function getMemberByID () {
    await fetch(BASE_URL + `members/get-member/${member_id}`)
    .then((response) => response.json())
    .then((data) => {
        setMember(data.member)
    })
   
    .catch((error) => console.log(error));
}

  async function getAttendance() {
    const endpoint = `memberAttendance/getMemberAttendanceByMemberId/${member_id}`;
  
    return fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setAttendance(data.attendance);
        setFilteredAttendance(data.attendance);
      })
      .catch((error) => {
        setAttendance([])
        console.log('error fetching attendance' , error);
      });
  }

  const handleDelete = async(id) => {
    setButtonLoading(true)
    setSelectedAttendance(id)
    const endpoint = `memberAttendance/deleteMemberAttendance/${id}`;
    const requestOptions = {
      method: "DELETE",
      headers: {
          "Content-Type": "application/json",
      },
    };

    await fetch(BASE_URL + endpoint , requestOptions)
    .then((response) => response.json())
    .then((data) => {
        getAttendance()
        setIsSuccessAlert(true)
        setSuccessMessage('Attendance deleted Successfully')
        setIsPopupOpen(true)
        setTimeout(() => {
            setIsPopupOpen(false)
        }, 5000)
    })
    .catch((error) => {
        console.log(error)
        setIsFailureAlert(true)
        setFailureMessage('Failed to delete Attendance')
        setIsPopupOpen(true)
        setTimeout(() => {
            setIsPopupOpen(false)
        }, 5000)
    }).finally(() => {
      setButtonLoading(false);
      setSelectedAttendance(null);
    });
  }
  const handleFilter = () => {
    if (!fromDate || !toDate) {
      setFilteredAttendance(attendance); 
      return;
    }

    const filteredData = attendance.filter((attend) => {
      const createdAt = new Date(attend.created_at);
      const from = new Date(fromDate);
      from.setHours(0,0,0,0)
      const to = new Date(toDate);
      to.setHours(23, 59, 59, 999)
      return createdAt >= from && createdAt <= to;
    });

    setFilteredAttendance(filteredData);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query) {
      setFilteredAttendance(attendance); // Reset to original data if empty
      return;
    }
    const filteredData = attendance.filter((attend) =>
      attend.status.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredAttendance(filteredData);
  };

  // Detect if filters are applied
  const hasFiltersApplied = useMemo(() => {
    return fromDate || toDate || searchQuery;
  }, [fromDate, toDate, searchQuery]);

  // Export handlers
  const handleExportAll = () => {
    MemberReport(attendance);
  };

  const handleExportWithFilters = () => {
    MemberReport(filteredAttendance);
  };

  const handleExportCurrentView = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const currentPageData = filteredAttendance.slice(startIndex, endIndex);
    MemberReport(currentPageData);
  };
  


  return (
    <>
    
      <div className="m-5 print:hidden">
        <PageHeader
          title="Member Attendance History"
          actions={
            <ExportDropdownMenu
              onExportAll={handleExportAll}
              onExportWithFilters={handleExportWithFilters}
              onExportCurrentView={handleExportCurrentView}
              hasFiltersApplied={hasFiltersApplied}
            />
          }
        />
      </div>

      <div className="flex items-center justify-between mt-5 ml-5">
        <div className="font-semibold text-lg">Member ID: <span className="font-normal">{member?.member_id}</span></div>
      </div>
      <div className="flex items-center justify-between mt-1 ml-5">
        <div className="font-semibold text-lg">Member Name: <span className="font-normal">{member?.name}</span></div>
      </div>

       <div className="relative m-5">
          <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-2 text-gx-ink-soft" />
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            className="border border-gx-border rounded-md py-1 px-2 pl-10 outline-0 w-72"
          />
        </div>

        
        <div className="w-full flex flex-col md:flex-row items-center justify-start gap-4 md:gap-8 md:mx-5">
    <div className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
        <label className="text-gx-ink font-semibold">From Date:</label>
        <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="border border-gx-border rounded-md py-1 px-3 outline-0 text-gx-ink-soft w-full md:w-48"
        />
    </div>

    <div className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
        <label className="text-gx-ink font-semibold">End Date:</label>
        <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            disabled={!fromDate}
            min={fromDate}
            className="border border-gx-border rounded-md py-1 px-3 outline-0 w-full md:w-48"
        />
    </div>

    <div className="flex items-center gap-1 w-full md:w-auto">
        <button
            onClick={handleFilter}
            className="bg-green-700 text-white hover:bg-green-800 py-1 px-2 rounded-md flex items-center justify-center gap-2 w-full md:w-auto"
        >
            Fetch Invoices
        </button>
    </div>
</div>

      { loading ? (
          
            <div className="flex justify-center items-center mt-20 relative">
              {/* SVG Gradient Definition */}
              <svg width="0" height="0">
                <defs>
                  <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#D71920" />
                    <stop offset="100%" stopColor="#F7931E" />
                  </linearGradient>
                </defs>
              </svg>
      
              {/* Circular Progress with Gradient Stroke */}
              <CircularProgress
                thickness={4}
                size={35}
                sx={{
                  'svg circle': {
                    stroke: 'url(#gradientColors)', // Apply gradient stroke
                  },
                }}
              />
            </div>
         
        )  : filteredAttendance && filteredAttendance.length !== 0 ? (
        <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Created On</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredAttendance.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((attend, index) => (
                <TableRow hover key={index}>
                  <TableCell>{attend.status}</TableCell>
                  <TableCell>{dayjs(attend.created_at).format('HH:MM A')}</TableCell>
                  <TableCell>{dayjs(attend.created_at).format('MMM DD, YYYY')}</TableCell>

                  <TableCell>
                    <div className="flex gap-2 justify-center items-center">
                      <div
                          className="text-gx-ink font-bold hover:cursor-pointer hover:text-red-700"
                            onClick={() => {
                              if(!buttonLoading && selectedAttendance !== attend._id) handleDelete(attend._id);
                            }}
                        >
                          <FontAwesomeIcon icon={faTrash} /> {buttonLoading && selectedAttendance === attend._id ? 'Deleting...' : 'Delete'}
                        </div>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={6}
                  count={filteredAttendance.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      ) : (
        <div className="bg-gx-border w-auto p-3 mt-10 rounded-lg m-10">
          <h3 className="text-xl font-bold text-center text-gx-ink-soft">
            No Records Found
          </h3>
        </div>
      )}
    
    {
      isPopupOpen && (
        <Popup
        onClose={() => setIsPopupOpen(false)}
        alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
        message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
        />
      )
    }
    </>
  );
}

export default MemberHistory;
